import namespace from "@rdfjs/namespace";
export const og = namespace("http://ogp.me/ns#");
